module.exports = __webpack_public_path__ + "static/media/it.fab9af5e.svg";